import React from "react";
import type { IPhotoLibraryPhoto, IPhotoLibrarySection } from "../../../interfaces/photoLibrary";
import { PhotoLibraryIcons } from "../../../utils/B2B/PhotoLibraryContent";
import "./fullPagePhotoViewer.scss";

interface IFullPagePhotoViewerProps {
	previewPhoto: IPhotoLibraryPhoto;
	photoLibrarySections: IPhotoLibrarySection[];
	setPreviewPhoto: (photo: IPhotoLibraryPhoto | null) => void;
}

const FullPagePhotoViewer = ({ previewPhoto, setPreviewPhoto, photoLibrarySections }: IFullPagePhotoViewerProps) => {
	const getCategoryDisplay = (photo: IPhotoLibraryPhoto) => {
		if (!photo.sectionId) return "Uncategorized";
		return (
			photoLibrarySections.find((section) => section.id === photo.sectionId)?.sectionName ?? "Uncategorized"
		);
	};

	return (
		<div className="photo-preview-modal" onClick={() => setPreviewPhoto(null)}>
			<div className="preview-content" onClick={(e) => e.stopPropagation()}>
				<img src={previewPhoto.fileUrl} alt={previewPhoto.fileName} />
				<div className="preview-info">
					<p className="preview-filename">{previewPhoto.fileName}</p>
					<div className="preview-category">
						<PhotoLibraryIcons.Folder />
						<span>{getCategoryDisplay(previewPhoto)}</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FullPagePhotoViewer;
